import $ from 'jquery'

export default class Default {
  constructor(main, shopify) {
    this.u = main.utils
    this.s = shopify

    //Default ajax settings
    this._defaults = shopify._ajax_defaults
  }

  get(opts) {
    const url = '/cart.js'
    const data = { ...opts.data }

    //coerce shopify into returning the damn template
    const settings = {
      ...this._defaults,
      url: url,
      data: JSON.stringify(data),
      type: 'GET',
      accepts: {
        text: 'text/html',
      },
      dataType: 'text',
      mimeType: 'text/html',
      success: (d) => {
        d = JSON.parse(d)
        console.log(d)
        if (typeof opts.callback == 'function') opts.callback(d)
      },
    }

    $.ajax(settings)
  }

  add(opts) {
    const url = '/cart/add.js'
    const data = $.extend(true, {}, opts.data)

    const settings = {
      ...this._defaults,
      url: url,
      data: data,
      contentType: 'application/x-www-form-urlencoded',
      type: 'POST',
      success: (d) => {
        if (typeof opts.callback == 'function') opts.callback(d)
      },
    }

    //Call url
    $.ajax(settings)
  }

  update(opts) {
    const url = '/cart/update.js'
    const data = $.extend(true, {}, opts.data)

    const settings = {
      ...this._defaults,
      url: url,
      data: data,
      contentType: 'application/x-www-form-urlencoded',
      type: 'POST',
      success: (d) => {
        if (typeof opts.callback == 'function') opts.callback(d)
      },
    }

    //Call url
    $.ajax(settings)
  }

  clear(opts) {
    const url = '/cart/clear.js'
    const data = $.extend(true, {}, opts.data)

    const settings = {
      ...this._defaults,
      url: url,
      data: JSON.stringify(data),
      type: 'POST',
      success: (d) => {
        if (typeof opts.callback == 'function') opts.callback(d)
      },
    }

    //Call url
    $.ajax(settings)
  }
}
